import { Box, TextField } from "@mui/material";
import { useState, useEffect } from "react";
import { parseDuration } from "../../../utils/formatting";
import type { FilterRenderProps } from "../../grid/CompGrid";
import type { GridDurationFilter } from "../../../types/filters";

export interface GridDurationFilterPopoverProps extends FilterRenderProps {
  label?: string;
}

export function GridDurationFilterPopover({
  value,
  onChange,
  label = "Duration",
}: GridDurationFilterPopoverProps) {
  const d = value as GridDurationFilter | undefined;
  const min = d?.min ?? null;
  const max = d?.max ?? null;

  const [minInput, setMinInput] = useState(min != null ? String(min) : "");
  const [maxInput, setMaxInput] = useState(max != null ? String(max) : "");

  useEffect(() => {
    setMinInput(min != null ? String(min) : "");
  }, [min]);
  useEffect(() => {
    setMaxInput(max != null ? String(max) : "");
  }, [max]);

  const applyMin = () => {
    const parsed = parseDuration(minInput);
    onChange({ min: parsed, max: max ?? null });
  };
  const applyMax = () => {
    const parsed = parseDuration(maxInput);
    onChange({ min: min ?? null, max: parsed });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, minWidth: 200 }}>
      <TextField
        size="small"
        label={`${label} min (ms, s)`}
        placeholder="Min"
        value={minInput}
        onChange={(e) => setMinInput(e.target.value)}
        onBlur={applyMin}
        onKeyDown={(e) => e.key === "Enter" && applyMin()}
      />
      <TextField
        size="small"
        label={`${label} max (ms, s)`}
        placeholder="Max"
        value={maxInput}
        onChange={(e) => setMaxInput(e.target.value)}
        onBlur={applyMax}
        onKeyDown={(e) => e.key === "Enter" && applyMax()}
      />
    </Box>
  );
}
